<template>
    <div class="tab-body">
        <div class="rigth-panel-header"></div>
        <div class="rigth-panel-body">
            <div class="right-panel-section-header">
                <div class="right-panel-section-header-title">Account names</div>
                <div class="right-panel-section-header-option">
                </div>
            </div>
            <div class="right-panel-section-body">
                <widgetProfile :title="`${user.first_name} ${user.last_name}`" :subtitle="user.email"
                    :file_name="user.profile_image" :path="$store.state.ASSETS_BASE_URL + '/assets/uploaded/'">
                </widgetProfile>
            </div>
            <template v-if="user.account_type == 'streamer'">
                <div class="right-panel-section-header">
                    <div class="right-panel-section-header-title">Account transation fee </div>
                    <div class="right-panel-section-header-option">
                    </div>
                </div>
                <div class="right-panel-section-body">
                    <b-field grouped group-multiline>
                        <div class="control">
                            <b-taglist attached>
                                <b-tag type="is-dark">Subscription Fee</b-tag>
                                <b-tag type="is-info">{{ user.subscription_fee }}%</b-tag>
                            </b-taglist>
                        </div>
                        <div class="control">
                            <b-taglist attached>
                                <b-tag type="is-dark">Streaming Fee</b-tag>
                                <b-tag type="is-success">{{ user.streaming_fee }}%</b-tag>
                            </b-taglist>
                        </div>
                        <div class="control">
                            <b-taglist attached>
                                <b-tag type="is-dark">Voting Fee</b-tag>
                                <b-tag type="is-primary">{{ user.voting_fee }}%</b-tag>
                            </b-taglist>
                        </div>
                    </b-field>
                    <b-field grouped group-multiline>
                        <div class="control">
                            <b-taglist attached>
                                <b-tag type="is-dark">E-Ticket Fee</b-tag>
                                <b-tag type="is-warning">{{ user.ticketing_fee }}%</b-tag>
                            </b-taglist>
                        </div>
                        <div class="control">
                            <b-taglist attached>
                                <b-tag type="is-dark">TopUp Voting Fee</b-tag>
                                <b-tag type="is-default">{{ user.topupVotesFee }}%</b-tag>
                            </b-taglist>
                        </div>
                        <div class="control">
                            <b-taglist attached>
                                <b-tag type="is-dark">Donation Fee</b-tag>
                                <b-tag type="is-success">{{ user.donation_fee }}%</b-tag>
                            </b-taglist>
                        </div>
                    </b-field>
                </div>
                <div class="right-panel-section-header">
                    <div class="right-panel-section-header-title">Account web domain registration</div>
                    <div class="right-panel-section-header-option">
                    </div>
                </div>
                <div class="right-panel-section-body" v-if="user.domain || user.subDomain">
                    <b-field grouped group-multiline>
                        <div class="control" v-if="user.domain">
                            <b-taglist attached>
                                <b-tag type="is-dark">Domain</b-tag>
                                <b-tag type="is-info">
                                    <a :href="`http://${user.domain}`" style="color: #fff;" target="_blank"
                                        rel="noopener noreferrer">{{ user.domain }}</a>
                                </b-tag>
                            </b-taglist>
                        </div>
                        <div class="control" v-if="user.subDomain">
                            <b-taglist attached>
                                <b-tag type="is-dark">Streaming Fee</b-tag>
                                <b-tag type="is-info">
                                    <a :href="`http://${user.subDomain}`" style="color: #fff;" target="_blank"
                                        rel="noopener noreferrer">{{ user.subDomain }}</a>
                                </b-tag>
                            </b-taglist>
                        </div>
                    </b-field>
                </div>
                <div class="right-panel-section-body" v-else>
                    <i class="fa fa-info icon"></i> Domain not set
                </div>
                <div class="right-panel-section-header">
                    <div class="right-panel-section-header-title">Website Category</div>
                    <div class="right-panel-section-header-option">
                    </div>
                </div>
                <div class="right-panel-section-body">
                    <b-tag type="is-dark">{{ user.domainCategory }}</b-tag>
                </div>
            </template>
        </div>
        <div class="rigth-panel-footer"></div>
    </div>
</template>
<script>
export default {
    components: {},
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
    data: () => ({

    }),
    watch: {},
    mounted() {

    },
    methods: {

    },
};
</script>
<style lang="scss" scoped>
.tab-body {
    height: calc(100% - 55px);
    display: flex;
    flex-direction: column;

    .rigth-panel-header {
        height: 0px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #ddd;
        padding: 0px 10px;
    }

    .rigth-panel-body {
        overflow-y: auto;
        height: calc(100% - 0px);

        .right-panel-section-header {
            background-color: #fff;
            padding: 0px 10px;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #ddd;

            .right-panel-section-header-title {
                font-size: 16px;
                font-weight: 500;
            }

            .right-panel-section-header-option {
                display: flex;
            }
        }

        .right-panel-section-body {
            padding: 10px;
        }

        .permission-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 0px;

            .permission-item-name {
                font-size: 14px;
                font-weight: 500;
            }

            .permission-item-option {
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }
        }
    }

    .rigth-panel-footer {
        height: 0px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top: 1px solid #ddd;
    }
}
</style>